import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Récupérer toutes les absences d'un étudiant
export const getLateByStudent = async (id_student, id_class, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/late/student/${id_student}/${id_class}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const createLate = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/late/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateLate = async (payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/late/update/${payload.id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteLate = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/late/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getLateByClass = async (
  id_class,
  id_courseVersionEDT,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/late/late/${id_class}/${id_courseVersionEDT}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
